import { ArrowLeftOutlined } from '@ant-design/icons'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './seq-milestone-list.module.scss'
import { MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'

type SeqMilestoneListProps = {
  milestones: MilestoneItem[]
  checkedMilestoneIds?: Set<number>
  onCheck: (milestone: MilestoneItem) => void
}

export const SeqMilestoneList = ({ milestones, onCheck, checkedMilestoneIds = new Set() }: SeqMilestoneListProps) => {
  const { t } = useTranslation()

  const [localCheckedIds, setLocalCheckedIds] = useState(checkedMilestoneIds)

  useEffect(() => {
    setLocalCheckedIds(checkedMilestoneIds)
  }, [checkedMilestoneIds])

  return (
    <div className={clsx(styles.wrapper, 'pt-3 px-2')}>
      <h6 className={clsx('text-center')}>{t('milestoneSequence.milestoneCheckHeader')}</h6>

      <div className={clsx('d-flex flex-column p-3')}>
        {milestones.map((milestone) => (
          <div
            key={`milestone_${milestone.id}`}
            className={clsx(styles.milestoneItem, {
              [styles.milestoneItemActive]: localCheckedIds.has(milestone.id),
            })}
            onClick={() => onCheck(milestone)}
          >
            <div>
              <ArrowLeftOutlined />
            </div>
            {milestone.name}
          </div>
        ))}
      </div>
    </div>
  )
}
